import * as Breadcrumbs from './Breadcrumbs';
import * as BuiltIn from './BuiltIn';
import CallOut from './CallOut';
import Cards from './Cards';
import Center from './Center';
import CollectionLink from './CollectionLink';
import Grid from './Grid';
import Head from './Head';
import { IFrame } from './IFrame';
import LinkCard from './LinkCard';
import MultiLanguage from './MultiLanguage';
import Space from './Space';
import TabbedExamples from './TabbedExamples';

const components = {
  CallOut,
  Cards,
  Center,
  CollectionLink,
  Grid,
  Head,
  LinkCard,
  MultiLanguage,
  Space,
  TabbedExamples,
  IFrame,
  ...BuiltIn,
  ...Breadcrumbs,
};

export default components;
